import { cn } from "@/design-system/lib/utils";
import type { WorkTaskPriority } from "@/api/workTasks";

interface Props {
  priority: WorkTaskPriority;
  className?: string;
}

const STYLE: Record<WorkTaskPriority, string> = {
  // Spec § 7 — design system tokens only.
  Low: "text-gray-mid",
  Medium: "text-onyx",
  High: "text-gold-shadow",
  Critical: "text-status-error",
};

const LABEL: Record<WorkTaskPriority, string> = {
  Low: "Low",
  Medium: "Medium",
  High: "High",
  Critical: "Critical",
};

export function TaskPriorityBadge({ priority, className }: Props) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-space-1",
        "font-display text-[10px] font-bold uppercase tracking-[0.16em]",
        STYLE[priority],
        className,
      )}
      aria-label={`Priority: ${LABEL[priority]}`}
    >
      {priority === "Critical" && (
        <span
          aria-hidden
          className="inline-block w-[6px] h-[6px] rounded-full bg-status-error"
        />
      )}
      {LABEL[priority]}
    </span>
  );
}
